// src/translations.js
const translations = {
    english: {
        // Nav
        all_inventory: 'All Inventory',
        raw_materials: 'Raw Materials',
        products: 'Products',
        packing_materials: 'Packing Materials',
        management: 'Management',
        activities: 'Activities',
        dispatch: 'Dispatch',
        analysis: 'Analysis',
        settings: 'Settings',
        logout: 'Logout',
        inventory_category: 'Inventory',
        management_category: 'Management',
        logout_confirm_title: 'Logout Confirmation',
        logout_confirm_msg: 'Are you sure you want to sign out?',
        logging_out: 'Logging Out...',
        logout_btn: 'Logout',

        // General
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        search: 'Search',
        export: 'Export',
        loading: 'Loading...',
        available: 'Available',
        all: 'All',
        no_data: 'No data found',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        name: 'Name',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        date: 'Date',
        quantity: 'Quantity',
        code: 'Code',
        batch: 'Batch',
        supplier: 'Supplier',
        description: 'Description',
        type: 'Type',
        total: 'Total',
        actions: 'Actions',
        filter: 'Filter',
        clear: 'Clear',
        back: 'Back',
        view_details: 'View details',
        created_at: 'Created at',
        updated_at: 'Updated at',
        kg: 'kg',
        units: 'units',
        pcs: 'pcs',
        total_quantity: 'Total Quantity',
        syncing_inventory: 'Syncing inventory data...',
        no_raw_stock: 'No raw materials with stock',
        no_products_stock: 'No products with stock',
        no_packing_stock: 'No packing inventory found',
        no_raw_found: 'No raw materials found',
        no_products_found: 'No products found',
        no_packing_found: 'No packing materials found',
        fetching_raw: 'Fetching raw materials...',
        fetching_products: 'Fetching products...',
        fetching_packing: 'Fetching packing materials...',
        fetching_dispatches: 'Fetching dispatches...',
        fill_required_fields: 'Please fill required fields',
        save_failed: 'Save failed',
        delete_failed_msg: 'Delete failed',
        export_confirm: 'Export Confirmation',
        export_msg: 'Are you sure you want to export this data to CSV?',
        download: 'Download',

        // Settings / Account
        add_user: 'Add user',
        language: 'Language',
        select_language: 'Select Language',
        english_lang: 'English',
        arabic_lang: 'Arabic',
        search_users: 'Search users...',
        admin: 'Admin',
        member: 'Member',
        workspace: 'Workspace',
        no_users_found: 'No users found',

        // Auth / App
        secure_signin: 'Securely signing you in...',
        session_expired_title: 'Session Expired',
        session_expired_msg: 'Please login again to continue.',
        ok_btn: 'OK',
        login_error_creds: 'These credentials are not associated to any workspace',
        failed_select_workspace: 'Failed to select workspace',
        sign_in_to_continue: 'Sign in to continue',
        dont_have_account: "Don't have an account?",
        contact_admin: 'Contact admin',
        sign_in: 'Sign In',
        select_workspace: 'Select Workspace',
        choose_workspace: 'Choose a workspace to continue working',
        sign_out_different_account: 'Sign out and use a different account',

        // Raw Materials
        raw_material: 'Raw material',
        material_name: 'Material name',
        material_code: 'Material Code',
        batch_no: 'Batch No',
        batch_number: 'Batch Number',
        available_qty: 'Available Qty',
        actual_qty: 'Actual Qty',
        stock: 'Stock (Rem / Total)',
        mfg_date: 'Mfg Date',
        receiving_date: 'Receiving Date',
        add_raw_material: 'Add raw material',
        edit_raw_material: 'Edit raw material',
        no_raw_materials: 'No raw materials found',
        filter_raw_materials: 'Filter raw materials',
        create_raw_material: 'Create raw material',
        manufacturing_date: 'Manufacturing Date',
        select_material: 'Select material',
        select_code: 'Select code',
        select_supplier: 'Select supplier',

        // Products
        product: 'Product',
        product_name: 'Product name',
        product_code: 'Product Code',
        add_product: 'Add product',
        edit_product: 'Edit product',
        no_products_found: 'No products found',
        filter_products: 'Filter products',
        create_product: 'Create product',
        expiry_date: 'Expiry Date',
        production_date: 'Production Date',
        product_qty: 'Product Quantity',
        gross_weight: 'Gross Weight',
        net_weight: 'Net Weight',
        raw_material_used: 'Raw Material Used',
        packaging_used: 'Packaging Used',
        group_products: 'Group Products',
        single_product: 'Single Product',
        create_group: 'Create Group',
        ingredients_materials: 'Ingredients / Materials',
        add_ingredient: 'Add Ingredient',
        select_product: 'Select product',
        add_raw_material_subproduct: 'Select raw material or sub-product',
        locked_remove_change: 'Locked — remove to change',
        insufficient_stock: 'Insufficient stock',
        calculated_weight_msg: 'Automatically calculated from ingredients total weight.',
        save_product: 'Save Product',
        products_in_group: 'Products in Group',
        mfg_date_shared: 'Manufacture Date (Shared)',
        shared_ingredients: 'Shared Ingredients',
        ingredient_desc: 'Used once for the entire group — deducted from stock once.',
        produced: 'Produced',
        sku_code: 'SKU / Code',
        in_stock: 'In Stock',
        out_of_stock: 'Out of Stock',
        add_at_least_one_product: 'Add at least one product',
        waste_person_name: 'Waste Person Name',
        waste_form_title: 'Report Waste / Deficit',
        waste_type: 'Waste Type',
        deficit: 'Deficit',
        waste: 'Waste',
        comment: 'Comment',
        time: 'Time',
        report_waste: 'Report Waste',
        yield_summary: 'Yield Summary',
        total_input: 'Total Input',
        total_output: 'Total Output',
        management_subtitle: 'Manage your suppliers, packaging materials, customers, products, and raw materials.',
        edit_product_definition: 'Edit Product Definition',
        add_product_definition: 'Add Product Definition',
        edit_raw_material_definition: 'Edit Raw Material Definition',
        add_raw_material_definition: 'Add Raw Material Definition',
        save_error: 'Failed to save. Please try again.',
        delete_error: 'Failed to delete. Please try again.',
        no_raw_found: 'Raw material not found',
        fetching_material_details: 'Fetching material details...',
        material_usage_diagram: 'Material Usage Diagram',
        inventory_status: 'Inventory Status',
        actual_quantity: 'Actual Quantity',
        available_quantity: 'Available Quantity',
        products_using_this_material: 'Products Using This Material',
        loading_products: 'Loading products...',
        no_products_using_this_material: 'No products found using this material.',
        raw_material_qty_used: 'Qty Used (Raw)',
        view_product_details: 'View product details',
        material_overview: 'Material Overview',
        usage_flow_for: 'Usage flow for',
        export_material_report: 'Export Material Report',
        export_material_report_msg_long: 'This will generate a comprehensive PDF report including general information, inventory status, product usage history, and the material flow diagram.',
        start_export: 'Start Export',
        preparing_overview: 'Preparing product overview...',
        fetching_product_details: 'Fetching product details...',
        switching_views: 'Switching views...',
        analysis_overview: 'Detailed analytics and custom report builder.',
        builder_desc: 'Build custom reports by selecting data sources, axes, and metrics.',
        custom_report_builder: 'Custom Report Builder',
        saved_analysis_reports: 'Saved Analysis Reports',
        report_builder: 'Report Builder',
        back_to_graphs: 'Back to Graphs',
        data_sources: 'Data Sources',
        loading_sources: 'Loading sources...',
        date_range: 'Date Range',
        new_report: 'New Report',
        run_report: 'Run Report',
        incomplete_config: 'Incomplete Configuration',
        report_saved: 'Report saved successfully',
        report_updated: 'Report updated successfully',
        select_axis: 'Select Axis',
        filter_label: 'Filter',
        search_values: 'Search values...',
        loading_values: 'Loading values...',
        no_values_found: 'No values found',
        clear_all: 'Clear All',
        selected: 'selected',
        today: 'Today',
        week: 'Last 7 Days',
        month: 'Last 30 Days',
        year: 'Last Year',
        calculated_waste: 'Calculated Waste',
        manufacturing_lineage_diagram: 'Manufacturing Lineage Diagram',
        group_production_flow: 'Group Production Flow',
        export_btn: 'Export',
        see_overview: 'See Overview',
        general_information: 'General Information',
        quantity_produced: 'Quantity Produced',
        remaining_in_stock: 'Remaining in Stock',
        manufactured_date: 'Manufactured Date',
        ingredients_used: 'Ingredients Used',
        no_ingredients_used: 'No ingredients used',
        qty_used: 'Qty Used',
        waste_records: 'Waste / Tested Records',
        person: 'Person',
        tested: 'Tested',
        product_used_to_make_products: 'Used to make these products',
        consumed_qty: 'Consumed Qty',
        dispatch_history: 'Dispatch History',
        loading_history: 'Loading history...',
        no_dispatch_history: 'No dispatch history for this product.',
        preparing_overview: 'Preparing product overview...',
        fetching_product_details: 'Fetching product details...',
        switching_views: 'Switching views...',
        ingredient: 'Ingredient',
        fetching_material_details: 'Fetching material details...',
        material_usage_diagram: 'Material Usage Diagram',
        inventory_status: 'Inventory Status',
        actual_quantity: 'Actual Quantity',
        available_quantity: 'Available Quantity',
        products_using_this_material: 'Products Using This Material',
        loading_products: 'Loading products...',
        no_products_using_this_material: 'No products found using this material.',
        raw_material_qty_used: 'Qty Used (Raw)',
        view_product_details: 'View product details',
        material_overview: 'Material Overview',
        usage_flow_for: 'Usage flow for',
        export_material_report: 'Export Material Report',
        export_material_report_msg_long: 'This will generate a comprehensive PDF report including general information, inventory status, product usage history, and the material flow diagram.',
        start_export: 'Start Export',
        no_dispatches_found: 'No dispatches found',
        dispatch_save_failed: 'Dispatch save failed',
        fill_dispatch_fields: 'Please fill in Customer, Driver, Car details, and PO Number.',
        delete_group: 'Delete Group',
        delete_group_warning: 'This will delete the entire production group and {count} associated products. This action cannot be undone.',

        // Packing Materials
        packing_material: 'Packing Material',
        packaging_material: 'Packaging Material',
        add_packing: 'Add packing material',
        edit_packing: 'Edit packing material',
        no_packing_found: 'No packing materials found',
        received_qty: 'Received Qty',
        min_qty: 'Minimum Qty',
        arrival_date: 'Arrival Date',
        add_received: 'Add received',
        add_arrival: 'Add Arrival',
        filter_records: 'Filter records',
        syncing_records: 'Syncing records...',
        remaining_qty: 'Remaining Qty',
        no_records_found: 'No records found',
        record_arrival: 'Record Arrival',
        batch_lot_no: 'Batch / Lot No',
        quantity_received: 'Quantity Received',
        edit_record: 'Edit Record',
        packaging_materials: 'Packaging Materials',
        filter_materials: 'Filter materials',
        syncing_materials: 'Syncing materials...',
        no_materials_found: 'No materials found',
        deleted_material: 'Deleted Material',
        deleted_supplier: 'Deleted Supplier',
        edit_packaging_material: 'Edit packaging material',
        add_packaging_material_long: 'Add packaging material',

        // Dispatch
        dispatch_order: 'Dispatch Order',
        customer: 'Customer',
        region: 'Region',
        dispatched_qty: 'Dispatched Qty',
        add_dispatch: 'Add dispatch',
        edit_dispatch: 'Edit dispatch',
        no_dispatches: 'No dispatches found',
        filter_dispatch: 'Filter dispatch',
        dispatch_date: 'Dispatch Date',
        vehicle_number: 'Vehicle Number',
        driver_name: 'Driver Name',
        remarks: 'Remarks',

        // Management
        suppliers: 'Suppliers',
        customers: 'Customers',
        regions: 'Regions',
        add_supplier: 'Add supplier',
        add_customer: 'Add customer',
        add_region: 'Add region',
        supplier_name: 'Supplier Name',
        supplier_code: 'Supplier Code',
        contact: 'Contact',
        address: 'Address',
        phone: 'Phone',
        no_suppliers: 'No suppliers found',
        no_customers: 'No customers found',
        no_regions: 'No regions found',
        edit_supplier: 'Edit supplier',
        edit_customer: 'Edit customer',
        edit_region: 'Edit region',
        customer_name: 'Customer Name',
        region_name: 'Region Name',
        customer_code: 'Customer Code',
        management_subtitle: 'Manage suppliers, packaging, customers, and product definitions',
        add_material: 'Add material',
        packaging: 'Packaging',
        weight_handler: 'Weight Handler',
        min_qty_required: 'Min Qty Required',
        min_qty_threshold: 'Min Qty Threshold',
        add_raw_material_definition: 'Add Raw Material Definition',
        edit_raw_material_definition: 'Edit Raw Material Definition',
        add_product_definition: 'Add Product Definition',
        edit_product_definition: 'Edit Product Definition',
        add_packaging_material: 'Add Packaging Material',
        edit_packaging_material: 'Edit Packaging Material',
        create: 'Create',
        customer_code: 'Customer Code',
        management_subtitle: 'Manage suppliers, packaging, customers, and product definitions',
        add_material: 'Add material',
        packaging: 'Packaging',
        weight_handler: 'Weight Handler',
        min_qty_required: 'Min Qty Required',
        min_qty_threshold: 'Min Qty Threshold',
        add_raw_material_definition: 'Add Raw Material Definition',
        edit_raw_material_definition: 'Edit Raw Material Definition',
        add_product_definition: 'Add Product Definition',
        edit_product_definition: 'Edit Product Definition',
        add_packaging_material: 'Add Packaging Material',
        edit_packaging_material: 'Edit Packaging Material',
        create: 'Create',

        // Activity
        activity_log: 'Activity Log',
        no_activities: 'No activities found',
        no_activities_recorded: 'No activities recorded yet.',
        activity_history: 'Activity History',
        latest_actions: 'LATEST ACTIONS',
        refresh: 'Refresh',
        updating_logs: 'Updating logs...',
        failed_fetch_logs: 'Failed to fetch activity logs',
        action: 'Action',
        user: 'User',
        performed_by: 'Performed By',
        timestamp: 'Timestamp',

        // Analysis
        total_raw_materials: 'Total Raw Materials',
        total_products: 'Total Products',
        total_dispatched: 'Total Dispatched',
        total_packaging: 'Total Packaging',
        overview: 'Overview',
        reports: 'Reports',
        analysis_overview: 'Overview of production, sales, and supply chain metrics.',
        builder_desc: 'Build custom reports by dragging and dropping fields.',
        custom_report_builder: 'Custom Report Builder',
        saved_analysis_reports: 'Custom Analysis Reports',
        no_data_range: 'No data for the selected range',
        report_builder: 'Report Builder',
        back_to_graphs: 'Back to Simple Graphs',
        data_sources: 'Data Sources',
        date_range: 'Date Range',
        today: 'Today',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        new_report: 'New Report',
        run_report: 'Run Report',
        visualizations: 'Visualizations',
        data_mapping: 'Data Mapping',
        axis_shared: 'Axis (Shared)',
        values_metrics: 'Values (Metrics)',
        select_grouping: 'Select grouping field',
        add_metrics_compare: 'Add multiple metrics to compare',
        welcome_canvas: 'Welcome to Interactive Report Canvas',
        pick_axis_value: 'Pick an Axis and some Value fields to start plotting',
        analyzing_sources: 'Analyzing data sources...',
        by: 'by',
        rename: 'RENAME',
        aggregation: 'AGGREGATION',
        color: 'COLOR',
        multiplier: 'MULTIPLIER',
        sum: 'Sum',
        avg: 'Average',
        count: 'Count',
        distinct_count: 'Distinct Count',
        list_distinct: 'List (Distinct)',
        min: 'Min',
        max: 'Max',
        edit_report: 'Edit Report',
        delete_report: 'Delete Report',
        custom_date_range: 'Custom Date Range',
        clear_all: 'Clear All',
        selected: 'Selected',
        filter_label: 'Filter',
        search_values: 'Search values...',
        no_values_found: 'No values found',
        loading_values: 'Loading values...',
        select_axis: 'Select Axis',
        report_updated: 'Report updated successfully!',
        report_saved: 'Report successfully saved to dashboard!',
        incomplete_config: 'Incomplete Configuration',
        loading_sources: 'Loading sources...',
        show_chart: 'Show Chart',
        show_table: 'Show Table',
        builder_error: 'Please select an Axis and at least one Value',
        fetch_failed: 'Failed to fetch data',
        stock_quantity: 'Stock Quantity',
        manufacture_date: 'Manufacture Date',
        export_date: 'Export Date',
        dispatched: 'Dispatched',
        used_in_product: 'Used in Product',
        initial_label: 'Initial',
        current_label: 'Current',
        to: 'to',
        on: 'on',
        product_lineage_overview: 'Product Lineage Overview',
        group_production_overview: 'Group Production Overview',
        material_usage_diagram: 'Material Usage Diagram',

        // Products/Dispatch/Customers additional
        sku_code: 'SKU / Code',
        produced: 'Produced',
        remaining: 'Remaining',
        in_stock: 'In stock',
        single_product: 'Single Product',
        create_group: 'Create Group',
        ingredients_materials: 'Ingredients / Materials',
        add_ingredient: 'Add ingredient',
        calculated_weight_msg: 'Calculated automatically from ingredients total weight.',
        insufficient_stock: 'Insufficient stock',
        locked_remove_change: 'Locked — remove to change',
        save_product: 'Save product',
        products_in_group: 'Products in Group',
        mfg_date_shared: 'Manufacture date (shared)',
        shared_ingredients: 'Shared Ingredients',
        ingredient_desc: 'Used once for the entire group — deducted from inventory once.',
        add_raw_material_subproduct: 'Select raw material or sub-product',
        fetching_products: 'Fetching products...',
        delete_failed: 'Delete failed',
        save_failed: 'Save failed',
        add_at_least_one_product: 'Add at least one product',
        create_dispatch_order: 'Create Dispatch Order',
        select_customer: 'Select customer',
        select_region: 'Select region',
        vehicle_no: 'Vehicle No',
        driver: 'Driver',
        dispatch_items: 'Dispatch Items',
        add_item: 'Add item',
        select_product_batch: 'Select product (batch)',
        qty_to_dispatch: 'Qty to dispatch',
        total_dispatch_weight: 'Total Dispatch Weight',
        save_dispatch: 'Save dispatch',

        // Inventory tabs
        unique_raw: 'Unique Raw Materials',
        unique_products: 'Unique Products',
        unique_packing: 'Unique Packing',
        all_packing: 'All Packing',
        total_quantity: 'Total Quantity',
        no_raw_materials: 'No raw materials found',
        no_products: 'No products found',
        out_of_stock: 'Out of stock',
        less: 'Less',
        abundant: 'Abundant',
        all_statuses: 'All Statuses',

        // Delete confirmation
        delete_confirm: 'Are you sure you want to delete',
        delete_warning: 'This action cannot be undone.',
        deleting: 'Deleting...',
        cancel_btn: 'Cancel',
        delete_btn: 'Delete',
        delete_confirmation_title: 'Delete Confirmation',
        edit_account: 'Edit Account',
        full_name: 'Full Name',
        password_placeholder: 'Enter password',
        password_edit_help: 'Password (leave blank to keep current)',
        enter_password: 'Enter password',
        healthy: 'HEALTHY',
        error_u: 'ERROR',
        system_health: 'System Health',
        frontend_service: 'Frontend Service',
        frontend_running: 'React application is running.',
        backend_api: 'Backend API',
        checking: 'Checking...',
        return_to_app: 'Return to Application',
        status_monitor: 'OmniTraceX Status Monitor',
    },
    arabic: {
        // Nav
        all_inventory: 'المخزون العام',
        raw_materials: 'المواد الخام',
        products: 'المنتجات',
        packing_materials: 'مواد التعبئة',
        management: 'الإدارة',
        activities: 'الأنشطة',
        dispatch: 'الشحن والإرسال',
        analysis: 'التحليل التقني',
        settings: 'الإعدادات',
        logout: 'تسجيل الخروج',
        inventory_category: 'المخزون',
        management_category: 'الإدارة',
        logout_confirm_title: 'تأكيد تسجيل الخروج',
        logout_confirm_msg: 'هل أنت متأكد أنك تريد تسجيل الخروج؟',
        logging_out: 'جاري تسجيل الخروج...',
        logout_btn: 'تسجيل الخروج',

        // General
        add: 'إضافة',
        edit: 'تعديل',
        delete: 'حذف',
        save: 'حفظ',
        cancel: 'إلغاء',
        close: 'إغلاق',
        search: 'بحث',
        export: 'تصدير',
        loading: 'جاري التحميل...',
        available: 'المتوفر',
        all: 'الكل',
        no_data: 'لا توجد بيانات',
        confirm: 'تأكيد',
        yes: 'نعم',
        no: 'لا',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        role: 'الدور',
        status: 'الحالة',
        date: 'التاريخ',
        quantity: 'الكمية',
        code: 'الرمز',
        batch: 'الدفعة',
        supplier: 'المورد',
        description: 'الوصف',
        type: 'النوع',
        total: 'الإجمالي',
        actions: 'الإجراءات',
        filter: 'تصفية',
        clear: 'مسح',
        back: 'رجوع',
        view_details: 'عرض التفاصيل',
        created_at: 'تاريخ الإنشاء',
        updated_at: 'تاريخ التحديث',
        kg: 'كجم',
        units: 'وحدات',
        pcs: 'قطع',
        total_quantity: 'إجمالي الكمية',
        syncing_inventory: 'جاري مزامنة بيانات المخزون...',
        no_raw_stock: 'لا توجد مواد خام في المخزون',
        no_products_stock: 'لا توجد منتجات في المخزون',
        no_packing_stock: 'لم يتم العثور على مخزون تعبئة',
        no_raw_found: 'لم يتم العثور على مواد خام',
        no_products_found: 'لم يتم العثور على منتجات',
        no_packing_found: 'لم يتم العثور على مواد تعبئة',
        fetching_raw: 'جاري جلب المواد الخام...',
        fetching_products: 'جاري جلب المنتجات...',
        fetching_packing: 'جاري جلب مواد التعبئة...',
        fetching_dispatches: 'جاري جلب الشحنات...',
        fill_required_fields: 'يرجى ملء الحقول المطلوبة',
        save_failed: 'فشلت عملية الحفظ',
        delete_failed_msg: 'فشل الحذف',
        export_confirm: 'تأكيد التصدير',
        export_msg: 'هل أنت متأكد أنك تريد تصدير هذه البيانات إلى ملف CSV؟',
        download: 'تحميل',

        // Settings / Account
        add_user: 'إضافة مستخدم',
        language: 'اللغة',
        select_language: 'اختر اللغة',
        english_lang: 'الإنجليزية',
        arabic_lang: 'العربية',
        search_users: 'البحث عن المستخدمين...',
        admin: 'مسؤول',
        member: 'عضو',
        workspace: 'مساحة العمل',
        no_users_found: 'لم يتم العثور على مستخدمين',

        // Auth / App
        secure_signin: 'جاري تسجيل الدخول بشكل آمن...',
        session_expired_title: 'انتهت الجلسة',
        session_expired_msg: 'يرجى تسجيل الدخول مرة أخرى للمتابعة.',
        ok_btn: 'موافق',
        customer_code: 'كود العميل',
        management_subtitle: 'إدارة الموردين والتعبئة والعملاء وتعاريف المنتجات',
        add_material: 'إضافة مادة',
        packaging: 'التعبئة والتغليف',
        weight_handler: 'معالج الوزن',
        min_qty_required: 'أقل كمية مطلوبة',
        min_qty_threshold: 'حد الكمية الأدنى',
        add_raw_material_definition: 'إضافة تعريف مادة خام',
        edit_raw_material_definition: 'تعديل تعريف مادة خام',
        add_product_definition: 'إضافة تعريف منتج',
        edit_product_definition: 'تعديل تعريف منتج',
        add_packaging_material: 'إضافة مادة تعبئة',
        edit_packaging_material: 'تعديل مادة تعبئة',
        create: 'إنشاء',
        select_axis: 'اختر المحور',
        report_updated: 'تم تحديث التقرير بنجاح!',
        report_saved: 'تم حفظ التقرير في لوحة المعلومات!',
        incomplete_config: 'إعداد غير مكتمل',
        loading_sources: 'جاري تحميل المصادر...',
        show_chart: 'عرض الرسم البياني',
        show_table: 'عرض الجدول',
        builder_error: 'يرجى اختيار محور واحد على الأقل وقيمة واحدة',
        fetch_failed: 'فشل في جلب البيانات',
        stock_quantity: 'كمية المخزون',
        manufacture_date: 'تاريخ التصنيع',
        export_date: 'تاريخ التصدير',
        dispatched: 'تم الشحن',
        used_in_product: 'مستخدم في المنتج',
        initial_label: 'الأصلي',
        current_label: 'الحالي',
        to: 'إلى',
        on: 'في',
        product_lineage_overview: 'نظرة عامة على تسلسل المنتج',
        group_production_overview: 'نظرة عامة على الإنتاج الجماعي',
        material_usage_diagram: 'مخطط استخدام المادة',
        login_error_creds: 'هذه الاعتمادات غير مرتبطة بأي مساحة عمل',
        failed_select_workspace: 'فشل في اختيار مساحة العمل',
        sign_in_to_continue: 'سجل الدخول للمتابعة',
        dont_have_account: 'ليس لديك حساب؟',
        contact_admin: 'اتصل بالمسؤول',
        sign_in: 'تسجيل الدخول',
        select_workspace: 'اختر مساحة العمل',
        choose_workspace: 'اختر مساحة عمل للمتابعة',
        sign_out_different_account: 'تسجيل الخروج واستخدام حساب آخر',

        // Raw Materials
        raw_material: 'المادة الخام',
        material_name: 'اسم المادة',
        material_code: 'رمز المادة',
        batch_no: 'رقم الدفعة',
        batch_number: 'رقم الدفعة',
        available_qty: 'الكمية المتاحة',
        actual_qty: 'الكمية الفعلية',
        stock: 'المخزون (المتبقي / الكلي)',
        mfg_date: 'تاريخ التصنيع',
        receiving_date: 'تاريخ الاستلام',
        add_raw_material: 'إضافة مادة خام',
        edit_raw_material: 'تعديل مادة خام',
        no_raw_materials: 'لم يتم العثور على مواد خام',
        filter_raw_materials: 'تصفية المواد الخام',
        create_raw_material: 'إنشاء مادة خام',
        manufacturing_date: 'تاريخ التصنيع',
        select_material: 'اختر المادة',
        select_code: 'اختر الرمز',
        select_supplier: 'اختر المورد',

        // Products
        product: 'المنتج',
        product_name: 'اسم المنتج',
        product_code: 'رمز المنتج',
        add_product: 'إضافة منتج',
        edit_product: 'تعديل منتج',
        no_products_found: 'لم يتم العثور على منتجات',
        filter_products: 'تصفية المنتجات',
        create_product: 'إنشاء منتج',
        expiry_date: 'تاريخ انتهاء الصلاحية',
        production_date: 'تاريخ الإنتاج',
        product_qty: 'كمية المنتج',
        gross_weight: 'الوزن الإجمالي',
        net_weight: 'الوزن الصافي',
        raw_material_used: 'المواد الخام المستخدمة',
        packaging_used: 'التعبئة المستخدمة',
        group_products: 'مجموعة منتجات',
        single_product: 'منتج واحد',
        create_group: 'إنشاء مجموعة',
        ingredients_materials: 'المكونات / المواد',
        add_ingredient: 'إضافة مكون',
        select_product: 'اختر المنتج',
        add_raw_material_subproduct: 'اختر مادة خام أو منتج فرعي',
        locked_remove_change: 'مقفل — قم بالإزالة للتغيير',
        insufficient_stock: 'مخزون غير كافٍ',
        calculated_weight_msg: 'يتم احتسابه تلقائياً من الوزن الإجمالي للمكونات.',
        save_product: 'حفظ المنتج',
        products_in_group: 'المنتجات في المجموعة',
        mfg_date_shared: 'تاريخ التصنيع (مشترك)',
        shared_ingredients: 'المكونات المشتركة',
        ingredient_desc: 'تستخدم مرة واحدة للمجموعة بأكملها — يتم خصمها من المخزون مرة واحدة.',
        produced: 'تم إنتاجه',
        sku_code: 'SKU / الرمز',
        in_stock: 'متوفر',
        out_of_stock: 'نفذ المخزون',
        add_at_least_one_product: 'أضف منتجاً واحداً على الأقل',
        waste_person_name: 'اسم الشخص المسؤول عن الهالك',
        waste_form_title: 'الإبلاغ عن هالك / نقص',
        waste_type: 'نوع الهالك',
        deficit: 'نقص',
        waste: 'هالك',
        comment: 'تعليق',
        time: 'الوقت',
        report_waste: 'الإبلاغ عن هالك',
        yield_summary: 'ملخص العائد',
        total_input: 'إجمالي المدخلات',
        total_output: 'إجمالي المخرجات',
        management_subtitle: 'إدارة الموردين ومواد التعبئة والتغليف والعملاء والمنتجات والمواد الخام.',
        edit_product_definition: 'تعديل تعريف المنتج',
        add_product_definition: 'إضافة تعريف منتج',
        edit_raw_material_definition: 'تعديل تعريف مادة خام',
        add_raw_material_definition: 'إضافة تعريف مادة خام',
        save_error: 'فشل الحفظ. يرجى المحاولة مرة أخرى.',
        delete_error: 'فشل الحذف. يرجى المحاولة مرة أخرى.',
        no_raw_found: 'المادة الخام غير موجودة',
        fetching_material_details: 'جاري جلب تفاصيل المادة...',
        material_usage_diagram: 'مخطط استخدام المادة',
        inventory_status: 'حالة المخزون',
        actual_quantity: 'الكمية الفعلية',
        available_quantity: 'الكمية المتاحة',
        products_using_this_material: 'المنتجات التي تستخدم هذه المادة',
        loading_products: 'جاري تحميل المنتجات...',
        no_products_using_this_material: 'لم يتم العثور على منتجات تستخدم هذه المادة.',
        raw_material_qty_used: 'الكمية المستخدمة (خام)',
        view_product_details: 'عرض تفاصيل المنتج',
        material_overview: 'نظرة عامة على المادة',
        usage_flow_for: 'تدفق الاستخدام لـ',
        export_material_report: 'تصدير تقرير المادة',
        export_material_report_msg_long: 'سيؤدي هذا إلى إنشاء تقرير PDF شامل يتضمن المعلومات العامة وحالة المخزون وسجل استخدام المنتج ومخطط تدفق المواد.',
        start_export: 'بدء التصدير',
        preparing_overview: 'جاري تحضير نظرة عامة على المنتج...',
        fetching_product_details: 'جاري جلب تفاصيل المنتج...',
        switching_views: 'جاري تبديل العرض...',
        analysis_overview: 'تحليلات مفصلة وباني تقارير مخصص.',
        builder_desc: 'قم ببناء تقارير مخصصة عن طريق اختيار مصادر البيانات والمحاور والمقاييس.',
        custom_report_builder: 'باني التقارير المخصصة',
        saved_analysis_reports: 'تقارير التحليل المحفوظة',
        report_builder: 'باني التقارير',
        back_to_graphs: 'العودة إلى الرسوم البيانية',
        data_sources: 'مصادر البيانات',
        loading_sources: 'جاري تحميل المصادر...',
        date_range: 'نطاق التاريخ',
        new_report: 'تقرير جديد',
        run_report: 'تشغيل التقرير',
        incomplete_config: 'تكوين غير مكتمل',
        report_saved: 'تم حفظ التقرير بنجاح',
        report_updated: 'تم تحديث التقرير بنجاح',
        select_axis: 'اختر المحور',
        filter_label: 'تصفية',
        search_values: 'البحث عن قيم...',
        loading_values: 'جاري تحميل القيم...',
        no_values_found: 'لم يتم العثور على قيم',
        clear_all: 'مسح الكل',
        selected: 'محدد',
        today: 'اليوم',
        week: 'آخر 7 أيام',
        month: 'آخر 30 يومًا',
        year: 'السنة الماضية',
        calculated_waste: 'الهالك المحسوب',
        manufacturing_lineage_diagram: 'مخطط تسلسل التصنيع',
        group_production_flow: 'تدفق إنتاج المجموعة',
        export_btn: 'تصدير',
        see_overview: 'عرض النظرة العامة',
        general_information: 'معلومات عامة',
        quantity_produced: 'الكمية المنتجة',
        remaining_in_stock: 'المتبقي في المخزون',
        manufactured_date: 'تاريخ التصنيع',
        ingredients_used: 'المكونات المستخدمة',
        no_ingredients_used: 'لا توجد مكونات مستخدمة',
        qty_used: 'الكمية المستخدمة',
        waste_records: 'سجلات الهالك / الفحص',
        person: 'الشخص',
        tested: 'تم فحصه',
        product_used_to_make_products: 'استخدم لصنع هذه المنتجات',
        consumed_qty: 'الكمية المستهلكة',
        dispatch_history: 'سجل الشحن',
        loading_history: 'جاري تحميل السجل...',
        no_dispatch_history: 'لا يوجد سجل شحن لهذا المنتج.',
        preparing_overview: 'جاري تحضير نظرة عامة على المنتج...',
        fetching_product_details: 'جاري جلب تفاصيل المنتج...',
        switching_views: 'جاري تبديل العرض...',
        ingredient: 'المكون',
        fetching_material_details: 'جاري جلب تفاصيل المادة...',
        material_usage_diagram: 'مخطط استخدام المادة',
        inventory_status: 'حالة المخزون',
        actual_quantity: 'الكمية الفعلية',
        available_quantity: 'الكمية المتاحة',
        products_using_this_material: 'المنتجات التي تستخدم هذه المادة',
        loading_products: 'جاري تحميل المنتجات...',
        no_products_using_this_material: 'لم يتم العثور على منتجات تستخدم هذه المادة.',
        raw_material_qty_used: 'الكمية المستخدمة (خام)',
        view_product_details: 'عرض تفاصيل المنتج',
        material_overview: 'نظرة عامة على المادة',
        usage_flow_for: 'تدفق الاستخدام لـ',
        export_material_report: 'تصدير تقرير المادة',
        export_material_report_msg_long: 'سيؤدي هذا إلى إنشاء تقرير PDF شامل يتضمن المعلومات العامة وحالة المخزون وسجل استخدام المنتج ومخطط تدفق المواد.',
        start_export: 'بدء التصدير',
        no_dispatches_found: 'لم يتم العثور على شحنات',
        dispatch_save_failed: 'فشل حفظ الشحنة',
        fill_dispatch_fields: 'يرجى ملء تفاصيل العميل والسائق والسيارة ورقم طلب الشراء.',
        delete_group: 'حذف المجموعة',
        delete_group_warning: 'سيؤدي هذا إلى حذف مجموعة الإنتاج بأكملها و {count} من المنتجات المرتبطة. لا يمكن التراجع عن هذا الإجراء.',

        // Packing Materials
        packing_material: 'مادة التعبئة',
        packaging_material: 'مادة التغليف',
        add_packing: 'إضافة مادة تعبئة',
        edit_packing: 'تعديل مادة تعبئة',
        no_packing_found: 'لم يتم العثور على مواد تعبئة',
        received_qty: 'الكمية المستلمة',
        min_qty: 'الحد الأدنى للكمية',
        arrival_date: 'تاريخ الوصول',
        add_received: 'إضافة مستلم',
        add_arrival: 'إضافة توريد',
        filter_records: 'تصفية السجلات',
        syncing_records: 'جاري مزامنة السجلات...',
        packaging_materials: 'مواد التعبئة والتغليف',
        filter_materials: 'تصفية المواد',
        syncing_materials: 'جاري مزامنة المواد...',
        no_materials_found: 'لم يتم العثور على مواد',
        deleted_material: 'مادة محذوفة',
        deleted_supplier: 'مورد محذوف',
        edit_packaging_material: 'تعديل مادة التعبئة',
        add_packaging_material_long: 'إضافة مادة تعبئة',
        remaining_qty: 'الكمية المتبقية',
        no_records_found: 'لم يتم العثور على سجلات',
        record_arrival: 'تسجيل توريد',
        batch_lot_no: 'رقم الدفعة / اللوط',
        quantity_received: 'الكمية المستلمة',
        edit_record: 'تعديل السجل',

        // Dispatch
        dispatch_order: 'أمر الشحن',
        customer: 'العميل',
        region: 'المنطقة',
        dispatched_qty: 'الكمية المشحونة',
        add_dispatch: 'إضافة شحنة',
        edit_dispatch: 'تعديل شحنة',
        no_dispatches: 'لم يتم العثور على شحنات',
        filter_dispatch: 'تصفية الشحنات',
        dispatch_date: 'تاريخ الشحن',
        vehicle_number: 'رقم المركبة',
        driver_name: 'اسم السائق',
        remarks: 'ملاحظات',

        // Management
        suppliers: 'الموردون',
        customers: 'العملاء',
        regions: 'المناطق',
        add_supplier: 'إضافة مورد',
        add_customer: 'إضافة عميل',
        add_region: 'إضافة منطقة',
        supplier_name: 'اسم المورد',
        supplier_code: 'رمز المورد',
        contact: 'جهة الاتصال',
        address: 'العنوان',
        phone: 'الهاتف',
        no_suppliers: 'لم يتم العثور على موردين',
        no_customers: 'لم يتم العثور على عملاء',
        no_regions: 'لم يتم العثور على مناطق',
        edit_supplier: 'تعديل مورد',
        edit_customer: 'تعديل عميل',
        edit_region: 'تعديل منطقة',
        customer_name: 'اسم العميل',
        region_name: 'اسم المنطقة',

        // Activity
        activity_log: 'سجل الأنشطة',
        no_activities: 'لا توجد أنشطة',
        no_activities_recorded: 'لم يتم تسجيل أي أنشطة بعد.',
        activity_history: 'سجل الأنشطة',
        latest_actions: 'أحدث الإجراءات',
        refresh: 'تحديث',
        updating_logs: 'جاري تحديث السجل...',
        failed_fetch_logs: 'فشل في جلب سجل الأنشطة',
        action: 'الإجراء',
        user: 'المستخدم',
        performed_by: 'بواسطة',
        timestamp: 'الوقت والتاريخ',

        // Analysis
        total_raw_materials: 'إجمالي المواد الخام',
        total_products: 'إجمالي المنتجات',
        total_dispatched: 'إجمالي المشحون',
        total_packaging: 'إجمالي التعبئة',
        overview: 'نظرة عامة',
        reports: 'التقارير',
        analysis_overview: 'نظرة عامة على مقاييس الإنتاج والمبيعات وسلسلة التوريد.',
        builder_desc: 'بناء تقارير مخصصة عن طريق سحب وإفلات الحقول.',
        custom_report_builder: 'باني التقارير المخصص',
        saved_analysis_reports: 'تقارير التحليل المخصصة',
        no_data_range: 'لا توجد بيانات للنطاق المحدد',
        report_builder: 'باني التقارير',
        back_to_graphs: 'الرجوع إلى الرسومات البسيطة',
        data_sources: 'مصادر البيانات',
        date_range: 'النطاق الزمني',
        today: 'اليوم',
        week: 'الأسبوع',
        month: 'الشهر',
        year: 'السنة',
        new_report: 'تقرير جديد',
        run_report: 'تشغيل التقرير',
        visualizations: 'التمثيلات المرئية',
        data_mapping: 'رسم خرائط البيانات',
        axis_shared: 'المحور (مشترك)',
        values_metrics: 'القيم (المقاييس)',
        select_grouping: 'اختر حقل التجميع',
        add_metrics_compare: 'أضف مقاييس متعددة للمقارنة',
        welcome_canvas: 'مرحباً بك في لوحة التقارير التفاعلية',
        pick_axis_value: 'اختر محوراً وبعض حقول القيم لبدء الرسم',
        analyzing_sources: 'جاري تحليل مصادر البيانات...',
        by: 'حسب',
        rename: 'إعادة تسمية',
        aggregation: 'التجميع',
        color: 'اللون',
        multiplier: 'المضاعف',
        sum: 'المجموع',
        avg: 'المتوسط',
        count: 'العدد',
        distinct_count: 'العدد الفريد',
        list_distinct: 'قائمة (فريدة)',
        min: 'الحد الأدنى',
        max: 'الحد الأقصى',
        edit_report: 'تعديل التقرير',
        delete_report: 'حذف التقرير',
        custom_date_range: 'نطاق زمني مخصص',
        clear_all: 'مسح الكل',
        selected: 'مختار',
        filter_label: 'تصفية',
        search_values: 'البحث عن القيم...',
        no_values_found: 'لم يتم العثور على قيم',
        loading_values: 'جاري تحميل القيم...',

        // Products/Dispatch/Customers additional
        sku_code: 'SKU / الرمز',
        produced: 'تم إنتاجه',
        remaining: 'المتبقي',
        in_stock: 'متوفر',
        single_product: 'منتج واحد',
        create_group: 'إنشاء مجموعة',
        ingredients_materials: 'المكونات / المواد',
        add_ingredient: 'إضافة مكون',
        calculated_weight_msg: 'يتم احتسابه تلقائياً من الوزن الإجمالي للمكونات.',
        insufficient_stock: 'مخزون غير كافٍ',
        locked_remove_change: 'مقفل — قم بالإزالة للتغيير',
        save_product: 'حفظ المنتج',
        products_in_group: 'المنتجات في المجموعة',
        mfg_date_shared: 'تاريخ التصنيع (مشترك)',
        shared_ingredients: 'المكونات المشتركة',
        ingredient_desc: 'تستخدم مرة واحدة للمجموعة بأكملها — يتم خصمها من المخزون مرة واحدة.',
        add_raw_material_subproduct: 'اختر مادة خام أو منتج فرعي',
        fetching_products: 'جاري جلب المنتجات...',
        delete_failed: 'فشل الحذف',
        save_failed: 'فشلت عملية الحفظ',
        add_at_least_one_product: 'أضف منتجاً واحداً على الأقل',
        create_dispatch_order: 'إنشاء أمر شحن',
        select_customer: 'اختر العميل',
        select_region: 'اختر المنطقة',
        vehicle_no: 'رقم المركبة',
        driver: 'السائق',
        dispatch_items: 'مواد الشحن',
        add_item: 'إضافة مادة',
        select_product_batch: 'اختر منتجاً (دفعة)',
        qty_to_dispatch: 'الكمية المراد شحنها',
        total_dispatch_weight: 'إجمالي وزن الشحنة',
        save_dispatch: 'حفظ الشحنة',

        // Inventory tabs
        unique_raw: 'المواد الخام الفريدة',
        unique_products: 'المنتجات الفريدة',
        unique_packing: 'التعبئة الفريدة',
        all_packing: 'كل التعبئة',
        total_quantity: 'الكمية الإجمالية',
        no_raw_materials: 'لم يتم العثور على مواد خام',
        no_products: 'لم يتم العثور على منتجات',
        out_of_stock: 'نفذ المخزون',
        less: 'قليل',
        abundant: 'متوفر',
        all_statuses: 'كل الحالات',

        // Delete confirmation
        delete_confirm: 'هل أنت متأكد من حذف',
        delete_warning: 'لا يمكن التراجع عن هذا الإجراء.',
        deleting: 'جاري الحذف...',
        cancel_btn: 'إلغاء',
        delete_btn: 'حذف',
        delete_confirmation_title: 'تأكيد الحذف',
        edit_account: 'تعديل الحساب',
        full_name: 'الاسم بالكامل',
        password_placeholder: 'أدخل كلمة المرور',
        password_edit_help: 'كلمة المرور (اتركها فارغة للإبقاء على الحالية)',
        enter_password: 'أدخل كلمة المرور',
        healthy: 'سليم',
        error_u: 'خطأ',
        system_health: 'صحة النظام',
        frontend_service: 'خدمة الواجهة الأمامية',
        frontend_running: 'تطبيق React يعمل بشكل صحيح.',
        backend_api: 'واجهة API الخلفية',
        checking: 'جاري الفحص...',
        return_to_app: 'العودة إلى التطبيق',
        status_monitor: 'مراقب حالة نظام OmniTraceX',
    }
};

export default translations;
